import React, { useState, useEffect } from 'react';
import { Box, Text, Avatar } from '@mantine/core';

interface PlayerStackProps {
  numCards: number;
  avatar?: string | null;
  name: string;
  onClick?: () => void;
  handwritingFont?: string;
}

const PlayerStack: React.FC<PlayerStackProps> = ({ 
  numCards, 
  avatar, 
  name, 
  onClick,
  handwritingFont 
}) => {
  return (
    <Box
      style={{
        width: '120px',
        height: '140px',
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick}
    >
      {/* Single card - polaroid style */}
      <Box
        style={{
          width: '120px',
          height: '140px',
          backgroundColor: 'white',
          borderRadius: '5px',
          padding: '8px',
          boxShadow: '0 4px 8px rgba(13, 163, 136, 0.15)',
        }}
      >
        {/* Avatar photo area - full bleed */}
        <Box
          style={{
            width: '104px',
            height: '104px',
            backgroundColor: '#ffffff',
            borderRadius: '4px',
            marginBottom: '8px',
            overflow: 'hidden',
            border: '1px solid #eee',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {avatar ? (
            <img
              src={avatar}
              alt={`${name}'s avatar`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                backgroundColor: '#ffffff',
              }}
            />
          ) : (
            <Avatar
              size={80}
              radius="sm"
              color="blue"
              style={{
                fontSize: '32px',
                fontWeight: 'bold',
              }}
            >
              {name?.charAt(0)?.toUpperCase() || '?'}
            </Avatar>
          )}
        </Box>

        {/* Name text area */}
        <Text
          size="xs"
          fw={500}
          ta="center"
          style={{
            fontFamily: handwritingFont ? `"${handwritingFont}", var(--mantine-font-family)` : 'var(--mantine-font-family)',
            color: '#666',
            lineHeight: 1.2,
            height: '20px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {name}
        </Text>
      </Box>
    </Box>
  );
};

export default PlayerStack;
